namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;

    export interface IState {
        id: number;
        code: string;
        description: string;
    }

	export class State implements IState {
		id: number;
		code: string;
		description: string;

		constructor(obj?: IState | psgm.LocationSharedStateModel) {
            this.id = null;
			this.code = '';
			this.description = '';

			if (isEither<IState, psgm.LocationSharedStateModel>(obj)) {
                this.id = obj.id || null;
				this.code = obj.code || '';
				this.description = obj.description || '';
            }
        }
    }
}
